import React, { useState } from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import ListingPageComponent from '../../components/ListingPageComponent';
import FiltersPartial from "./FiltersPartial.js";

const Index = () => {
  const defaultHeaderConfig = { disableSort: false };
  const [filtersModel, setFiltersModel] = useState({});
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      label: 'Owner',
      value: (row) => {
        return <div className="d-block">
          <div>{row.owner_name}</div>         
          <div>({row.owner_id})</div>          
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Serial Number',
      attr: 'serial_number',
      disableSort: true
    },
    {
      label: 'Invoice Number',
      attr: 'invoice_number',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Assigned At',
      attr: 'assigned_at',
    },
    {
      label: 'Inventory Code',
      attr: 'inventory_code',
      disableSort: true
    },
    {
      label: 'Status',
      attr: 'status',
      disableSort: true
    }
  ]

  return <>

    <ListingPageComponent
      key={PAGES.BatteriesListingPage.name}
      uiPage={uiManager.getUiPage(PAGES.BatteriesListingPage.name)}
      breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Battery' }]}
      listingMutation={getApi('batteries')}
      className="batteries-listing-page"
      contentHeading="All batteries - Results"
      headers={headers}
      recordsKey="batteries"
      filtersModel={filtersModel}
      filters={
        <FiltersPartial
          filtersModel={filtersModel}
          setFiltersModel={setFiltersModel}
        />
      }
      searchBy={['ID', 'Serial Number', 'Invoice Number']}
    />
  </>
};

export default Index;
